import { Category } from "types/category";
import { SubCategory } from "types/subCategory";

export enum AdApplyStatus {
    PENDING = "pending",
    HIRED = "hired",
    ACCEPTED = "accepted",
    REFUSED = "refused",
    CANCELLED = "cancelled",
    EXPIRED = "expired",
}

export enum AdFrequency {
    ONE_TIME = "ONE_TIME",
    RECURRING = "RECURRING",
}

export interface AdInterface {
    id: string;
    client_id: string;
    booking_id: string;
    title: string;
    frequency: AdFrequency;
    client: {
        user_id: string;
        last_name: string;
        first_name: string;
        address?: string;
        postcode: string;
        city: string;
        coordinates_lon: number;
        coordinates_lat: number;
        description: string;
        picture_id: string;
        dataleon_status: string;
        num_cesu: string;
        total_hours: number;
        rating?: { average: number | null; count: number };
        created_at: string;
    };
    category: Category;
    subcategory: SubCategory;
    description: string;
    duration: number;
    house_number?: string | null;
    street?: string | null;
    postcode?: string | null;
    city?: string | null;
    coordinates_lon?: number | string | null;
    coordinates_lat?: number | string | null;
    picture_id?: string;
    is_active: boolean;
    distance_from_provider: number;
    providers_fav: string[];
    providers_apply: string[];
    providers_active_apply: string[];
    provider_hired?: { provider_id: string } | null;
    provider_refused: string[];
    is_passed: boolean;
    created_at: string;
    updated_at: string;
    data: {
        device_type?: string[];
        required_hours?: string;
        start_date?: string;
        start_time?: string;
        end_date?: Date;
        end_time?: string;
        child_count?: string;
        child_age?: string[];
        watering_place?: string;
        bring_products?: boolean;
        bring_tools?: boolean;
        car_location?: string;
        vehicle_type?: string[];
        travel_range?: string;
        surface_type?: string;
        surface?: string;
        has_floor?: boolean;
        has_elevator?: boolean;
        care_place?: string[];
        pet_type?: string[];
        pet_count?: string;
        academic_level?: string[];
        scholar_subjects?: string[];
        foreign_languages?: string[];
        activities?: string[];
    };
}

export interface AdApplicationInterface {
    id?: string;
    service_id: string;
    ad_id?: string | null;
    source?: "ad_offer" | "direct";
    provider_id?: string;
    message: string;
    status: AdApplyStatus;
    hourly_rate: string | number;
    duration: string | number;
    amount: string | number;
    employer_contributions?: string | number;
    employee_contributions_ef?: string | number;
    activate_cesu_plus?: string | number | boolean;
    cesu_plus_status?: string | number | boolean;
    aici_status?: string | number | boolean;
    paid?: boolean;
    client_id?: string;
    start_date?: string | null;
    start_time?: string | null;
    mission_type: AdFrequency | string;
    booking?: {
        id: string;
        validated_at?: string | null;
        cancelled_at?: string | null;
    };
    ad?: {
        id: string;
        title: string;
        frequency: AdFrequency | string;
        duration?: number | null;
        client_id: string;
        category?: Category;
        subcategory?: SubCategory;
        is_active?: boolean;
        deleted_at?: string | null;
        booking?: {
            id: string;
            validated_at?: string | null;
            cancelled_at?: string | null;
        };
    } | null;
    service: {
        id: string;
        price: string | number;
        category?: Category;
        subcategory?: SubCategory;
    };
    provider?: {
        id: string;
        num_cesu?: string;
    };
    created_at: string;
    updated_at: string;
}
